import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import {
  getHotelLocation,
  getHotelCoordinates,
  getHotelMainImageHref,
  getHotelRoulette,
} from 'src/routes/Hotel/store/hotel';
import LazyYandexHotelMap from '../../components/YandexHotelMap/LazyYandexHotelMap';

import {
  getIsWebGlSupported,
  isMapViewSelector,
} from '../../store/selectors/view';
import { getMapBounds } from '../../store/selectors/map';

const mapStateToProps = (state) => ({
  coordinates: getHotelCoordinates(state),
  imageHref: getHotelMainImageHref(state),
  isWebGlSupported: getIsWebGlSupported(state),
  bounds: getMapBounds(state),
  location: getHotelLocation(state),
  isRoulette: getHotelRoulette(state),
  isMapView: isMapViewSelector(state),
  isMobile: getIsMobile(state),
});

export default connect(mapStateToProps)(LazyYandexHotelMap);
